<template>
    <div class="base-layout">
        <loader v-if="globalStatus('loading')" />

        <place-unavailable v-else-if="placeUnavailable" :variant="placeUnavailable" />

        <template v-else>
            <div class="base-layout-content">
                <router-view></router-view>
            </div>

            <reward-modal />
            <statement-modal />
            <faq-modal />
            <terms-modal />

            <redeem-success />
        </template>
    </div>
</template>
<style lang="scss">
.base-layout {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  background: #eee;
}

.base-layout-content {
  position: relative;
  flex: 1 1 auto;
  max-width: 100%;
}
</style>
<script>
import Loader from "./loader";
import { mapGetters } from "vuex";
import RewardModal from "../features/points/points-reward-modal";
import StatementModal from "../features/statement/statement-modal";
import FaqModal from "../features/info/faq-modal";
import TermsModal from "../features/info/terms-modal";
import RedeemSuccess from "../features/points/points-redeem-success";
import PlaceUnavailable from "./place-unavailable";

export default {
    components: {
        Loader,
        RewardModal,
        StatementModal,
        FaqModal,
        TermsModal,
        RedeemSuccess,
        PlaceUnavailable,
    },
    computed: {
        ...mapGetters(["globalStatus"]),
        placeUnavailable() {
            if (this.globalStatus("not-found")) {
                return "not-found";
            }

            return this.globalStatus("error") ? "error" : null;
        },
    },
};
</script>
